// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__G4bvq","header":"style_header__2o0qj"};